<template>
  <a ref="slide"
     :href="slideUrl"
     @click="handleRedirect($event, slideUrl)"
     class="hero-slider__item"
     :class="{'hero-slider__item--with-sidebar': withSidebar}"
  >
    <picture class="hero-slider__thumb">
      <source class="swiper-lazy"
              :srcset="slideMobWebp"
              type="image/webp"
              media="(max-width: 1023px)" />
      <source class="swiper-lazy" :srcset="slideMobImg" media="(max-width: 1023px)" />
      <source class="swiper-lazy" :srcset="slideWebp" type="image/webp" />
      <img
        class="swiper-lazy hero-slider__thumb"
        :src="slideImg"
        :loading="position === 1 ? 'eager' : 'lazy'"
        :fetchpriority="position === 1 ? 'high' : 'auto'"
        decoding="async"
        :alt="slideAlt"
      />
    </picture>
  </a>
</template>

<script>
import { transliteration } from '../../mixins/transliteration'
import { GoogleTagManagerService, GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'HeroSliderItem',
  mixins: [transliteration],
  props: {
    slideId: {
      type: [String, Number]
    },
    blockName: {
      type: String,
      default: ''
    },
    slideUrl: {
      type: String,
      default: ''
    },
    slideMobImg: {
      type: String,
      default: ''
    },
    withSidebar: {
      type: Boolean,
      default: false
    },
    slideMobWebp: {
      type: String,
      default: ''
    },
    slideWebp: {
      type: String,
      default: ''
    },
    slideImg: {
      type: String,
      default: ''
    },
    slideAlt: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: null
    }
  },
  methods: {
    async handleRedirect (e, link) {
      e.preventDefault()

      // await GoogleTagManagerService.promotionClickEvent({
      //   analyticsData: [
      //     {
      //       'name': this.transliterate(this.slideAlt),
      //       'creative': this.transliterate(this.blockName),
      //       'position': 'slot' + this.position
      //     }
      //   ]
      // })
      if (GoogleEnhancedEcommerce.isEnabled) {
        const fileName = this.slideImg.substring(this.slideImg.lastIndexOf('/') + 1)
        const imgName = fileName.split('.')[0]
        const data = {
          promotion_id: this.slideId.toString(), // якщо доступне значення
          promotion_name: this.slideAlt || imgName, // ім'я баннера https://imgur.com/VHwAxqr
          creative_slot: 'main_slider', // місце розташування слайдера
          index: this.position, // порядковый номер баннера
          universal_value: this.slideImg, // лінк на баннер
          banner_link: link
        }
        const savedBanners = localStorage.getItem('clickedBanners')
        const hasBanner = savedBanners && JSON.parse(savedBanners).find(el => el.promotion_id.toString() === this.slideId.toString())
        if (!hasBanner) {
          const allClickedBanners = savedBanners ? JSON.parse(savedBanners) : []
          allClickedBanners.push(data)
          localStorage.setItem('clickedBanners', JSON.stringify(allClickedBanners))
        }
        await GoogleEnhancedEcommerce.selectPromotion(data)
      } else {
        await GoogleTagManagerService.promotionClickEvent({
          analyticsData: [
            {
              'name': this.transliterate(this.slideAlt),
              'creative': this.transliterate(this.blockName),
              'position': 'slot' + this.position
            }
          ]
        })
      }
      setTimeout(() => {
        location.href = link
      }, 200)
    }
  },
  mounted () {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // GoogleTagManagerService.promotionViewEvent({
          //   analyticsData: [
          //     {
          //       'name': this.transliterate(this.slideAlt),
          //       'creative': this.transliterate(this.blockName),
          //       'position': 'slot' + this.position
          //     }
          //   ]
          // })

          // observer.unobserve(this.$refs.slide)
          if (GoogleEnhancedEcommerce.isEnabled) {
            const fileName = this.slideImg.substring(this.slideImg.lastIndexOf('/') + 1)
            const imgName = fileName.split('.')[0]
            GoogleEnhancedEcommerce.viewPromotion({
              promotion_id: this.slideId.toString(), // якщо доступне значення
              promotion_name: this.slideAlt || imgName, // ім'я баннера https://imgur.com/VHwAxqr
              creative_slot: 'main_slider', // місце розташування слайдера
              index: this.position, // порядковый номер баннера
              universal_value: this.slideImg // лінк на баннер
            })
          } else {
            GoogleTagManagerService.promotionViewEvent({
              analyticsData: [
                {
                  'name': this.transliterate(this.slideAlt),
                  'creative': this.transliterate(this.blockName),
                  'position': 'slot' + this.position
                }
              ]
            })
          }
        }
      },
      { threshold: 0.2 }
    )
    setTimeout(() => {
      observer.observe(this.$refs.slide)
    }, 0)
  }
}
</script>

<style scoped lang="sass">

.hero-slider__item
  padding-top: 55.6%
  +mmin($tablet--hor)
    padding-top: 27.6%

  &--with-sidebar
    padding-top: 47.8%

.hero-slider__thumb
  position: absolute
  top: 0
  left: 0
  width: 100%
</style>
